export enum AppointmentCreatedByEnum {
    MANAGER = 'MANAGER',
    CONSULTANT = 'CONSULTANT',
}